import { useState } from "react"
import Header from "../components/Header"

const TABS = ["Sourcing", "Application Review", "AI Interviews", "Human + AI Co-pilot"]

function CheckIcon() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" style={{ flexShrink: 0, marginTop: 2 }}>
      <path d="M2.5 7.5L6 11L12.5 4" stroke="#1a2e1f" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default function PricingPage() {
  const [activeTab, setActiveTab] = useState("Application Review")
  const STOPS = [
    { interviews: 50,  price: 249 },
    { interviews: 100,  price: 499 },
    { interviews: 150, price: 749 },
    { interviews: 200, price: 999 },
    { interviews: 250, price: 1249 },
    { interviews: 300, price: 1499 },
  ]
  const [stopIndex, setStopIndex] = useState(0)
  const { interviews, price: proPrice } = STOPS[stopIndex]

  return (
    <>
      <style>{`
        @import url('https://fonts.cdnfonts.com/css/euclid-circular-a');

        * { box-sizing: border-box; margin: 0; padding: 0; }

        .pricing-root {
          min-height: auto;
          font-family: 'Euclid Circular A', sans-serif;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 0 24px 80px;
        }

        .pricing-label {
          font-size: 15px;
          font-weight: 400;
          color: #1a3327;
          margin-bottom: 14px;
          letter-spacing: 0.01em;
        }

        .pricing-headline {
          font-size: 48px;
          font-weight: 500;
          color: #0d1f14;
          text-align: center;
          line-height: 1.08;
          margin-bottom: 36px;
          letter-spacing: -0.02em;
        }

        .tabs-row {
          display: flex;
          align-items: center;
          gap: 4px;
          margin-bottom: 40px;
        }

        .tab-btn {
          font-family: 'Euclid Circular A', sans-serif;
          font-size: 14px;
          font-weight: 500;
          padding: 10px 22px;
          border-radius: 4px;
          border: none;
          cursor: pointer;
          background: transparent;
          color: #1a3327;
          transition: background 0.15s, color 0.15s;
        }

        .tab-btn.active {
          background: #0d1f14;
          color: #ffffff;
        }

        .white-box {
          background: #ffffff;
          border-radius: 20px;
          padding: 30px;
          width: 100%;
          max-width: 1280px;
          border: 1px solid #e5e5e3;
        }

        /* ── Desktop: subgrid so card/btn/features rows align across cols ── */
        .plans-grid {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          grid-template-rows: auto auto auto;
          gap: 16px;
        }

        .plan-col {
          display: grid;
          grid-template-rows: subgrid;
          grid-row: span 3;
          gap: 16px;
        }

        .plan-col .plan-card {
          height: 100%;
        }

        .plan-col .cta-btn {
          align-self: stretch;
          margin-top: 8px;
        }

        .features-col {
          padding: 0 4px;
        }

        .plan-card {
          background: #e4f4ed;
          border-radius: 14px;
          padding: 22px 24px 24px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          min-height: 190px;
        }

        .plan-subtitle {
          font-size: 14px;
          font-weight: 400;
          color: rgba(1, 5, 27, 0.56);
          margin-bottom: 6px;
          line-height: 22px;
        }

        .plan-name {
          font-size: 36px;
          font-weight: 500;
          color: rgb(0, 0, 0);
          line-height: 42px;
          margin-bottom: 0;
        }

        .plan-price-row {
          margin-top: 0;
          display: flex;
          align-items: baseline;
          gap: 6px;
        }

        .plan-price-amount {
          font-size: 28px;
          font-weight: 500;
          color: rgb(0, 0, 0);
          line-height: 34px;
        }

        .plan-name {
          font-size: 36px;
          font-weight: 500;
          color: rgb(0, 0, 0);
          line-height: 42px;
          margin-bottom: 0;
        }

        .plan-price-unit {
          font-size: 14px;
          font-weight: 500;
          color: rgba(1, 5, 27, 0.56);
          line-height: 20px;
        }

        .plan-tailored {
          font-size: 14px;
          font-weight: 400;
          color: rgb(0, 0, 0);
          margin-top: 0;
          line-height: 20px;
        }

        .slider-label {
          font-size: 14px;
          font-weight: 400;
          color: rgb(0, 0, 0);
          margin-bottom: 8px;
          margin-top: 0;
          line-height: 20px;
        }

        .slider-outer {
          position: relative;
          height: 24px;
          display: flex;
          align-items: center;
          margin-bottom: 4px;
          overflow: visible;
        }

        .slider-track-bg {
          position: absolute;
          left: 8px; right: 8px;
          top: 50%;
          transform: translateY(-50%);
          height: 1px;
          background: #b8d8c6;
          pointer-events: none;
        }

        .slider-ticks {
          position: absolute;
          left: 8px; right: 8px;
          top: 50%;
          display: flex;
          justify-content: space-between;
          pointer-events: none;
        }

        .slider-tick {
          width: 1px;
          height: 8px;
          background: #b8d8c6;
          transform: translateY(-50%);
        }

        .custom-slider {
          -webkit-appearance: none;
          appearance: none;
          position: relative;
          z-index: 2;
          width: 100%;
          height: 24px;
          background: transparent;
          outline: none;
          cursor: pointer;
          margin: 0;
          padding: 0;
          overflow: visible;
        }

        .custom-slider::-webkit-slider-container {
          overflow: visible;
        }

        .custom-slider::-webkit-slider-runnable-track {
          height: 1px;
          background: transparent;
          border: none;
        }

        .custom-slider::-webkit-slider-thumb {
          -webkit-appearance: none;
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #0d1f14;
          cursor: pointer;
          border: none;
          margin-top: -7.5px;
        }

        .custom-slider::-moz-range-track {
          height: 1px;
          background: transparent;
          border: none;
        }

        .custom-slider::-moz-range-thumb {
          width: 16px;
          height: 16px;
          border-radius: 50%;
          background: #0d1f14;
          cursor: pointer;
          border: none;
        }
        .cta-btn {
          font-family: 'Euclid Circular A', sans-serif;
          font-size: 16px;
          font-weight: 600;
          color: #ffffff;
          background: #0d1f14;
          border: none;
          border-radius: 999px;
          padding: 18px 0;
          cursor: pointer;
          width: 100%;
          transition: opacity 0.15s;
          letter-spacing: 0.01em;
        }

        .cta-btn:hover { opacity: 0.88; }

        .features-row {
          display: grid;
          grid-template-columns: 1fr 1fr 1fr;
          gap: 16px;
          padding: 0 4px;
        }

        .features-tagline {
          font-size: 13px;
          font-weight: 400;
          color: #5a8a6a;
          margin-bottom: 12px;
          line-height: 1.4;
        }

        .features-list {
          list-style: none;
          display: flex;
          flex-direction: column;
          gap: 9px;
        }

        .feature-item {
          display: flex;
          align-items: flex-start;
          gap: 9px;
          font-size: 14px;
          font-weight: 400;
          color: #1a2e1f;
          line-height: 1.4;
        }

        /* ── Mobile ── */
        @media (max-width: 768px) {

          .pricing-root {
            padding: 0 16px 60px;
            padding-top: 48px !important;
          }

          .pricing-headline {
            font-size: 32px;
            margin-bottom: 24px;
          }

          .tabs-row {
            flex-wrap: wrap;
            justify-content: center;
            gap: 6px;
            margin-bottom: 28px;
          }

          .tab-btn {
            font-size: 13px;
            padding: 8px 14px;
          }

          .white-box {
            background: transparent;
            border: none;
            padding: 0;
            border-radius: 0;
          }

          .plans-grid {
            grid-template-columns: 1fr;
            gap: 16px;
          }

          .plan-col {
            display: grid;
            grid-template-rows: auto auto auto;
            gap: 12px;
            background: #ffffff;
            border: 1px solid #e5e5e3;
            border-radius: 16px;
            padding: 20px;
          }

          .plan-col .plan-card {
            background: #e4f4ed;
            border-radius: 12px;
            min-height: 200px;
          }

          .plan-card {
            min-height: 200px;
            padding: 18px 20px 20px;
          }

        }

      `}</style>

      <div style={{ minHeight: "100vh", background: "#f9f9f7", fontFamily: "'Euclid Circular A', sans-serif" }}>
        <Header />
        <div className="pricing-root" style={{ background: "none", paddingTop: 96 }}>
        <p className="pricing-label">Pricing</p>

        <h1 className="pricing-headline">
          Pick what you need.<br />
          Pay for what you use.
        </h1>

        <div className="tabs-row">
          {TABS.map((tab) => (
            <button
              key={tab}
              className={`tab-btn${activeTab === tab ? " active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="white-box">

          {/* Plans: each col = card + button + features */}
          <div className="plans-grid">

            {/* Free */}
            <div className="plan-col">
              <div className="plan-card">
                <div>
                  <p className="plan-subtitle">Get started</p>
                  <p className="plan-name">Free</p>
                </div>
                <div className="plan-price-row">
                  <span className="plan-price-amount">$0</span>
                  <span className="plan-price-unit">monthly</span>
                </div>
              </div>
              <button className="cta-btn">Start for free</button>
              <div className="features-col">
                <p className="features-tagline">Try AI Application Review with no commitment.</p>
                <ul className="features-list">
                  <li className="feature-item"><CheckIcon />Agentic ATS</li>
                  <li className="feature-item"><CheckIcon />500 applications per month</li>
                  <li className="feature-item"><CheckIcon />Advanced screening</li>
                </ul>
              </div>
            </div>

            {/* Pro */}
            <div className="plan-col">
              <div className="plan-card">
                <div>
                  <p className="plan-subtitle">For the curious</p>
                  <p className="plan-name">Pro</p>
                </div>
                <div>
                  <p className="slider-label">{interviews.toLocaleString()} Interviews / month</p>
                  <div className="slider-outer">
                    <div className="slider-track-bg" />
                    <div className="slider-ticks">
                      {STOPS.map((_, i) => (
                        <div key={i} className="slider-tick" />
                      ))}
                    </div>
                    <input
                      type="range"
                      className="custom-slider"
                      min={0}
                      max={5}
                      step={1}
                      value={stopIndex}
                      onChange={(e) => setStopIndex(Number(e.target.value))}
                    />
                  </div>
                  <div className="plan-price-row">
                    <span className="plan-price-amount">${proPrice.toLocaleString()}</span>
                    <span className="plan-price-unit">monthly</span>
                  </div>
                </div>
              </div>
              <button className="cta-btn">Book a demo</button>
              <div className="features-col">
                <p className="features-tagline">Enhanced screening for your hiring pipeline.</p>
                <ul className="features-list">
                  <li className="feature-item"><CheckIcon />Unlimited Applicants</li>
                  <li className="feature-item"><CheckIcon />AI Interviews</li>
                  <li className="feature-item"><CheckIcon />Human + AI Co-pilot</li>
                </ul>
              </div>
            </div>

            {/* Enterprise */}
            <div className="plan-col">
              <div className="plan-card">
                <div>
                  <p className="plan-subtitle">For organizations</p>
                  <p className="plan-name">Enterprise</p>
                </div>
                <p className="plan-tailored">Tailored pricing</p>
              </div>
              <button className="cta-btn">Book a demo</button>
              <div className="features-col">
                <p className="features-tagline">Custom solutions for large organizations.</p>
                <ul className="features-list">
                  <li className="feature-item"><CheckIcon />Custom volume &amp; usage</li>
                  <li className="feature-item"><CheckIcon />Dedicated support &amp; training</li>
                  <li className="feature-item"><CheckIcon />SSO Integration</li>
                </ul>
              </div>
            </div>

          </div>{/* end plans-grid */}

        </div>{/* end white-box */}
        </div>{/* end pricing-root */}
      </div>{/* end outer gradient */}
    </>
  )
}